import store from '@/store';
import { router } from '@/router';
import moment from "moment";
import Vue from 'vue';
import _ from "lodash";
import LogService from '@/services/LogService';

function initialState() {
    return {
        updated_Notifications: [],
        rows_count: null
    }
}

const state = initialState();

const mutations = {
    Updated_Notification_List: (state, payload) => {
        state.updated_Notifications = payload.Records;
        state.rows_count = payload.notoficationtotalcount;
    }
}

const actions = {
    SendNotificationLog: ({ dispatch, commit, state }, payload) => {
        LogService.SendNotificationLog(payload).then(response => {

            const { data } = response;

            if (data && data.status) {

            } else {
                console.error('Status Error on SendNotificationLog :', data.message);
            }
        }).catch((error) => {
            console.error('Catch Error on SendNotificationLog :', error);
        });
    },

    GetNotifications: ({ dispatch, commit, state }, payload) => {
        LogService.GetAllNotification(payload)
            .then(response => {
                const { data } = response;

                if (data.status) {
                    commit('Updated_Notification_List', data);
                } else {
                    console.error('Status Error on GetNotifications :', data.message);
                }
            })
            .catch(this._CatchError);
    },

    UpdateNotification: ({ dispatch, commit, state }, payload) => {
        LogService.UpdateNotificationStatus(payload).then(response => {
            const { data } = response;

            if (data && data.status) {
                commit('Updated_Notification_List', data);
            }
        }).catch((error) => {
            console.error('Catch Error on UpdateNotificationStatus :', error);
        });
    }
}

const getters = {
    NotificationList: state => state.updated_Notifications,
    RowsCount: state => state.rows_count,

}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/NotificationLogs_Store.js